import clsx from 'clsx'
import React, { cloneElement, FunctionComponent, ReactElement } from 'react'
import { Transition as ReactTransition, TransitionStatus } from 'react-transition-group'

import { TIME_OUT } from './constant'
import styles from './style.module.scss'

export const Transition: FunctionComponent<any> = ({ children, ...props }) => {
  const nodeRef = React.useRef(null)
  type CSSClasses = keyof typeof styles
  return (
    <ReactTransition timeout={TIME_OUT} nodeRef={nodeRef} {...props}>
      {(status: TransitionStatus) => {
        const className = (children as ReactElement).props.className as CSSClasses
        return (
          children != null &&
          cloneElement(children as ReactElement, {
            ref: nodeRef,
            className: clsx(className, styles[status]),
          })
        )
      }}
    </ReactTransition>
  )
}
